import { render, staticRenderFns } from "./ProjectWasteSubmissionForm.vue?vue&type=template&id=8c0d67fa"
import script from "./ProjectWasteSubmissionForm.vue?vue&type=script&lang=js"
export * from "./ProjectWasteSubmissionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports